import { useAuth } from './useAuth'
import { useSubscription } from './useSubscription'
import { hasPermission, resourceAccess } from '../lib/access'

export function useAccess() {
  const { user, isLoading: authLoading } = useAuth()
  const subscription = useSubscription()
  return {
    user, subscription,
    isLoading: authLoading || subscription.isLoading,
    has: (permission: string) => hasPermission(user, permission),
    resource: (name: string) => resourceAccess(user, subscription, name),
  }
}
